import * as React from 'react';
import { Avatar, Button, CssBaseline, TextField, Link, Grid2, Box, Typography, Container, IconButton, InputAdornment } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Visibility, VisibilityOff } from '@mui/icons-material';
// import logo from '../../images/Logo.png'
import Loading from '../setup/Loading'
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import ErrorMsg from '../../BuiltInComponent/ErrorMsg'

import { login } from '../../features/auth/authSlice'
import { getCompanyData } from '../../features/setup/useableSlice'

export default function Login() {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { user, isLoading } = useSelector(state => state.auth)

    const [userData, setUserData] = React.useState({
        userName: '',
        userPassword: ''
    })

    const [showPassword, setShowPassword] = React.useState(false)

    const handleOnChange = (e) => {
        setUserData({
            ...userData,
            [e.target.name]: e.target.value
        })
    }

    React.useEffect(() => {
        if (user) {
            navigate('/Dashboard')
        }
    }, [user, navigate])

    const loginUser = (e) => {
        e.preventDefault()
        dispatch(login(userData)).then((res) => {
            dispatch(getCompanyData())
        })
    }

    return (
        <Container>
            <CssBaseline />
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {/* <img src={logo} height={70} width={70} alt='' onClick={() => navigate("/")} /> */}
                <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Sign in
                </Typography>
                {isLoading ? (<Loading />) : (<></>)}
                {/* {errMsg ? (<Typography style={{
                    backgroundColor: 'red',
                    padding: 10,
                    margin: 10,
                    borderRadius: 20,
                    color: 'white',
                    minWidth: 250,
                    textAlign: 'center'
                }}>
                    {errMsg}
                </Typography>) : (<></>)} */}
                <Box component="form" onSubmit={loginUser} noValidate sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="userName"
                        label="Enter User ID"
                        name="userName"
                        autoComplete="userName"
                        autoFocus
                        onChange={handleOnChange}
                    // onFocus={() => setErrorMessage('')}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="userPassword"
                        label="Password"
                        type={showPassword ? "text" : "password"}
                        id="userPassword"
                        autoComplete="userPassword"
                        onChange={handleOnChange}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword(!showPassword)}
                                        onMouseDown={(e) => e.preventDefault()}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    // onFocus={() => setErrorMessage('')}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Sign In
                    </Button>
                    <Grid2 container>
                        <Grid2 size={12}>
                            {global.msgError !== '' ?
                                <><ErrorMsg message={global.msgError} msgColor='red' /></> : <></>
                            }
                        </Grid2>
                        <Grid2>
                            <Link href="/" variant="body2">
                                Forgot password?
                            </Link>
                        </Grid2>
                        <Grid2>
                            <Link href="/" variant="body2">
                                {"Don't have an account? Sign Up"}
                            </Link>
                        </Grid2>
                    </Grid2>
                </Box>
            </Box>
        </Container>
    );
}
